import React from"react";
import WishlistButton from "./WishlistButton";
function Kids(){
    return <div className="Kids">

    <div className ="mencard">
 <div className="catalog-section-title"> <h1>Kids Corner</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length Party Dress  (Multicolor, Sleeveless).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Girls MidiKnee Length Party Dress  (Multicolor, Sleeveless)</h6>
<p></p>
<h4> ₹259 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 
   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys & Girls Casual Solid Denim  (White, Pack of 1).jpeg"} alt="" /></div>
<div className="card-header"><h6>Dungaree For Boys & Girls Casual Solid Denim  (White, Pack of 1)</h6><h4> ₹344 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 
   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MaxiFull Length FestiveWedding Dress  (Multicolor, Fashion Sleeve).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Girls Maxi/Full Length Festive/Wedding Dress  (Multicolor, Fashion Sleeve)</h6><h4> ₹424 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

    <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys & Girls Casual Self Design Denim  (White, Pack of 1).jpeg"} alt="" /></div>
<div className="card-header"><h6>Dungaree For Boys & Girls Casual Self Design Denim  (White, Pack of 1)</h6><h4> ₹429 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls Midi Knee Length Party Dress  (Multicolor, 3 4 Sleeve).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Girls Midi Knee Length Party Dress  (Multicolor, 3 4 Sleeve)</h6><h4> ₹315 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls Calf Length Party Dress  (Dark Blue, 3 4 Sleeve).jpeg"} alt="" /></div>
<div className="card-header"><h6>Girls Calf Length Party Dress  (Dark Blue, 3 4 Sleeve)</h6><h4> ₹445 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys Casual Embroidered Denim  (Blue, Pack of 1).jpeg"} alt="" /></div>
<div className="card-header"><h6>Dungaree For Boys Casual Embroidered Denim  (Blue, Pack of 1)</h6><h4> ₹399 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 
   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys & Girls Casual Self Design Cotton Blend  (Red, Pack of 2).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Dungaree For Boys & Girls Casual Self Design Cotton Blend  (Red, Pack of 2)</h6><h4> ₹689 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys Self Design Cotton Blend  (Multicolor, Pack of 1).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Dungaree For Boys Self Design Cotton Blend  (Multicolor, Pack of 1)</h6><h4> ₹641</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 
   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys & Girls Casual Printed Denim, Cotton Blend  (Multicolor, Pack of 1).jpeg"} alt="" /></div>
<div className="card-header"><h6>Dungaree For Boys & Girls Casual Printed Denim, Cotton Blend  (Multicolor, Pack of 1)</h6><h4> ₹379</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length Casual Dress  (Yellow, Sleeveless).jpeg"} alt="" /></div>
<div className="card-header"><h6>Girls Midi/Knee Length Casual Dress  (Yellow, Sleeveless)</h6><h4> ₹321</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length FestiveWedding Dress  (Multicolor, 3 4 Sleeve).jpeg"} alt="" /></div>
<div className="card-header"><h6>Girls MidiKnee Length FestiveWedding Dress  (Multicolor, 3 4 Sleeve)</h6><p></p><h4> ₹299</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 
   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length Casual Dress  (White, Sleeveless).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Girls MidiKnee Length Casual Dress  (White, Sleeveless)</h6><h4> ₹188</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length Casual Dress  (Pink, Sleeveless).jpeg"} alt="" /></div>
<div className="card-header"><h6>Girls Midi/Knee Length Casual Dress  (Pink, Sleeveless)</h6><h4> ₹350</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length Party Dress  (Red, Sleeveless).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Girls Midi/Knee Length Party Dress  (Red, Sleeveless)</h6><h4> ₹389</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Dungaree For Boys & Girls Casual Solid Denim  (Blue, Pack of 1).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Dungaree For Boys & Girls Casual Solid Denim  (Blue, Pack of 1)</h6><h4> ₹399</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Barbie Girls MidiKnee Length Party Dress  (Multicolor, Fashion Sleeve).jpeg"} alt="" /></div>
<div className="card-header"><h6>Barbie Girls Midi/Knee Length Party Dress  (Multicolor, Fashion Sleeve)</h6><h4> ₹379</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls MidiKnee Length Casual Dress  (Blue, Sleeveless).jpeg"} alt="" /></div>
<div className="card-header"><h6>Girls Midi/Knee Length Casual Dress  (Blue, Sleeveless)</h6>  <h4> ₹306</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Barbie Girls MidiKnee Length Party Dress  (Red, Sleeveless).jpeg"} alt="" /></div>
<div className="card-header"><h6>Barbie Girls Midi/Knee Length Party Dress  (Red, Sleeveless)</h6><h4> ₹316</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

   <div className="pricing-column col-lg-3 col-md-6">
  <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Girls Below Knee Casual Dress  (Blue, Sleeveless).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Girls Below Knee Casual Dress  (Blue, Sleeveless)</h6><h4> ₹845</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 </div>
 </div>

 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Kids Toys</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/My Baby Excels Plush Doll Pink with Stripes 35 cm  (Pink).jpeg"}alt=""  /></div>
<div className="card-header"><h6>My Baby Excels Plush Doll Pink with Stripes 35 cm  (Pink)</h6><h4> ₹469</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/My Baby Excels Plush Doll Blue with Stripes 35 cm - 35 cm  (Blue).jpeg"} alt="" /></div>
<div className="card-header"><h6>My Baby Excels Plush Doll Blue with Stripes 35 cm - 35 cm  (Blue)</h6><h4> ₹469</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

  <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/My Baby Excels Plush Doll Red with Stripes 35 cm  (Red).jpeg"} alt="" /></div>
<div className="card-header"><h6>My Baby Excels Plush Doll Red with Stripes 35 cm  (Red)</h6> <h4> ₹989</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body"><img className ="kidsimage"src={process.env.PUBLIC_URL + "/images/kidsimages/Ard Enterprise Candy Girl Stuffed Toy-Purple  (Purple).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Ard Enterprise Candy Girl Stuffed Toy-Purple  (Purple)</h6><h4> ₹289</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>



</div>}
export default Kids;